import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  BaseService,
  HttpClient,
  HttpHeaders,
  HttpParams,
} from './base.service';
import { IInvoiceItem } from '../shared/api';
import { AccountService } from './account.service';

@Injectable()
export class InvoiceItemService extends BaseService<IInvoiceItem> {
  constructor(accountService: AccountService, http: HttpClient) {
    super(accountService, http, 'invoiceItem');
  }
}

export { IInvoiceItem } from '../shared/api';
